export default __webpack_public_path__ + "3323765551a47625203f5bfce10bb601.svg";